var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSetLo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.7495C10.4069 11.7495 11.75 10.4064 11.75 8.74951C11.75 7.09266 10.4069 5.74951 8.75 5.74951C7.09315 5.74951 5.75 7.09266 5.75 8.74951C5.75 10.4064 7.09315 11.7495 8.75 11.7495Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.407 14.4067L10.164 18.6497C9.78899 19.0243 9.28059 19.2348 8.7505 19.2348C8.22042 19.2348 7.71202 19.0243 7.337 18.6497L3.093 14.4067C1.97422 13.2879 1.21234 11.8624 0.903691 10.3106C0.595043 8.75873 0.753494 7.15022 1.35901 5.68844C1.96452 4.22665 2.9899 2.97725 4.30548 2.09821C5.62107 1.21918 7.16777 0.75 8.75 0.75C10.3322 0.75 11.8789 1.21918 13.1945 2.09821C14.5101 2.97725 15.5355 4.22665 16.141 5.68844C16.7465 7.15022 16.905 8.75873 16.5963 10.3106C16.2877 11.8624 15.5258 13.2879 14.407 14.4067Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetLo);
export default __webpack_public_path__ + "static/media/icon_set_lo.cfd71d22f0e2c4616ac734849e8d8c62.svg";
export { ForwardRef as ReactComponent };